import React from 'react'
import { TextField } from '@material-ui/core'
import { useInput, Validator } from 'react-admin'
import { minutesToHoursPattern, hoursPatternToMinutes } from './utils'
import { OpeningHourRowProps } from './index'
import { OpeningHours } from '@vacinas-net/shared'
import { isNumber } from 'lodash'

const validator: Validator = (value, formValues, inputProps) => {
  const name = inputProps.name as string
  const keys = name.split('.')
  const globalIndex = Number(keys[1])
  const inputBaseSource = keys[0]
  const openingHours: OpeningHours[] = formValues[inputBaseSource] || []
  const targetOpeningHour = openingHours[globalIndex]

  if (!targetOpeningHour) return null
  const isWeekdayActive =
    formValues?.weekdayOpeningHours[inputBaseSource][
      `weekday-${targetOpeningHour.weekday}`
    ]
  if (!isWeekdayActive) return null

  if (!isNumber(value)) return

  const startDateTimeInputValue = targetOpeningHour.startTimeInMinutes

  if (isNumber(startDateTimeInputValue) && startDateTimeInputValue > value) {
    return 'O horário de início não pode ser posterior ao horário de fim'
  }

  return null
}

const EndDateTimeInput = (props: OpeningHourRowProps) => {
  const rowSource = `${props.inputBaseSource}.${props.openingHour.globalIndex}`
  const endDateTimeSource = `${rowSource}.endTimeInMinutes`
  const input = useInput({
    source: endDateTimeSource,
    value: null,
    validate: validator,
  })

  return (
    <TextField
      error={input.meta.error}
      disabled={props.disabled}
      type="time"
      style={{
        width: 150,
      }}
      label="Fim"
      variant="outlined"
      value={minutesToHoursPattern(input.input.value)}
      onChange={(event) => {
        const value = event.target.value
        const newValue = hoursPatternToMinutes(value)
        input.input.onChange(newValue)
      }}
      inputProps={{
        'data-testid': `input-end-date`,
      }}
      size="small"
      InputLabelProps={{ shrink: true }}
    />
  )
}

export default EndDateTimeInput
